import Vue from 'vue'

//引入axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//引入登录拦截
import store from "@/store";

import loading from "@/utils/loading";

import { MessageBox } from "element-ui";

import message from "@/utils/message";

import url from '@/utils/url'

import encrypt from "./encrypt";

import AES from "./AES";

import qs from 'qs';

//定义前端url前缀
const feUrl = url.feUrl;
//定义后端url前缀
const reUrl = url.reUrl;

axios.defaults.baseURL = reUrl;
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true;
// http request 拦截器
axios.interceptors.request.use(
    config => {
        //loading.show();//全局loading
        //判断token是否存在
        if (store.state.sessionId) {
            //将token设置成请求头
            config.headers.Authorization = store.state.sessionId;
        }
        let aesKey = AES.generatekey(16);
        //console.log(aesKey);
        let encryptKey = encrypt.rsaEncrypt(aesKey);
        // 参数处理
        if (config.method === 'GET' || config.method === 'get') {
            let urlSplit = config.url.split('?');
            if (urlSplit[1]) {
                //console.log("get urlSplit[1]",urlSplit[1]);
                let data = qs.parse(urlSplit[1]);
                let encryptData = AES.encrypt(JSON.stringify(data), aesKey)
                config.url = urlSplit[0] + "?" + "encryptKey=" + encryptKey + "&encryptData=" + encryptData;
                //console.log("get",config.url);
            }
        }
        if (config.method === 'POST' || config.method === 'post') {
            let data = config.data;
            // console.log("post", config.data);
            config.data = {
                encryptData: AES.encrypt(JSON.stringify(data), aesKey),
                encryptKey: encryptKey
            };
            // console.log("post", config.data);
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
// http response 拦截器
axios.interceptors.response.use(
    res => {
        // console.log(res);
        // RSA解密
        if (res.data.data && res.data.encrypted) {
            let aesKey = encrypt.rsaDecrypt(res.data.encrypted);
            //console.log(aesKey);
            let dataStr = AES.decrypt(res.data.data, aesKey);
            //console.log(dataStr);
            res.data.data = JSON.parse(dataStr);
        }
        //console.log(res);
        if (res.data.code === 102) {
            window.localStorage.removeItem('username');
            window.localStorage.removeItem('sessionId');
            window.parent.location.href = feUrl + '/login.html';
            /*MessageBox.alert('登录状态已失效，请重新登录', '登录状态失效', {
                confirmButtonText: '确定',
                callback: () => {
                    window.localStorage.removeItem('adminToken');
                    window.parent.location.href = feUrl + '/login.html';
                }
            });*/
        } else if (res.data.code === 500) {
            message.error('服务器故障，请重试');
        } else if (res.data.code === 403) {
            message.error(res.data.msg);
        }

        //loading.close();
        return res;
    },
    error => {
        //loading.close();
        return Promise.reject(error);
    }
);


function request(object) {
    if (!object.loading && object.loading !== false) {
        loading.show();
    }
    axios({
        method: object.method,
        url: object.url,
        data: object.data,
        responseType: object.responseType,
        timeout: object.timeout
    }).then((res) => {
        const data = res.data;
        if (data.code !== 403) {
            if (isFunction(object.success)) {
                object.success(data);
            }
        } else {
            if (isFunction(object.unauthorized)) {
                object.unauthorized(data);//没有权限
            }
        }
        if (!object.loading) {
            console.log('loading-close')
            loading.close()
        }
    }).catch((error) => {
        console.log('******** 请求失败 **********');
        console.log(error)
        if (isFunction(object.error)) {
            object.error(error);
        } else {
            message.error('请求超时失败');
        }
        if (!object.loading) {
            loading.close()
        }
    });
}

function isFunction(func) {
    return func && typeof func == 'function'
}

function executeReq(object) {
    if (object.confirm) {
        MessageBox.confirm(object.confirm, object.title ? object.title : '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            request(object);
        }).catch(() => { })
    } else {
        request(object);
    }
}

export default {
    get(object) {
        object.method = 'GET';
        if (object.data) {
            object.data = qs.stringify(JSON.parse(JSON.stringify(object.data)));
            object.url = object.url + "?" + object.data;
        }
        //console.log(object.data)
        //console.log(object.url);
        executeReq(object);
    },
    post(object) {
        object.method = 'POST';
        executeReq(object);
    },
    put(object) {
        object.method = 'PUT';
        executeReq(object);
    },
    delete(object) {
        object.method = 'DELETE';
        executeReq(object);
    }

}

